import { ADMISSION_POLICIES } from './admissionPolicies.js'
import { MUSIC_TYPES } from './musicTypes.js'

/** The SubKrewe fields that decide how a member may join it */
export interface JoinableSubkrewe {
  admission_policy?: string | null
  sponsored?: boolean | null
  music?: string | null
  visible_in_browser?: boolean | null
  specialty?: string[] | null
}

/**
 * Whether a member may join this SubKrewe themselves, with no captain's
 * approval and no pre-approval: an open policy, not sponsored (that waives
 * dues), not a band hidden from the browser, not a red shirt pool or internal
 * group. firestore.rules enforces the same on a member's own record; every
 * other join goes through a captain, an admin or /api/subkrewes/join (which
 * checks a pre-approval).
 */
export function isDirectlyJoinable(subkrewe: JoinableSubkrewe | null | undefined): boolean {
  if (!subkrewe) return false
  const policy = subkrewe.admission_policy || ADMISSION_POLICIES.OPEN
  const specialty = Array.isArray(subkrewe.specialty) ? subkrewe.specialty : []
  return (policy === ADMISSION_POLICIES.OPEN || policy === ADMISSION_POLICIES.OPEN_WITH_RESTRICTIONS)
    && subkrewe.sponsored !== true
    && (subkrewe.music !== MUSIC_TYPES.BAND || subkrewe.visible_in_browser === true)
    && !specialty.some(s => s === 'redshirtFreeFloating' || s === 'redshirtNerdHerders' || s === 'internal')
}
